import React from 'react';
import { BRAND_DOMAIN } from '../../constants/Branding';

import './HelpView.scss';
import { connect } from 'react-redux';
import { RootState } from '../../models/RootState';

type StoreProps={
  langData:any;
}
const HelpView: React.FC<StoreProps> = (props) => {
  const {langData}=props;
  return (
    <div className="help-text">
      <div className="help-header">{langData?.['help_caps']}</div>
      <div className="help-line">{langData?.['live_chat']}</div>
      <div className="help-line">
      {langData?.['our_support_txt']}
      </div>
      <div className="help-line"> {langData?.['email_cps']}</div>
      <div className="help-line">
      {langData?.['email_us_txt']} support@{BRAND_DOMAIN} {langData?.['quote_name_txt']}
      </div>
      <div className="help-line">
      {langData?.['ques_offers_emailus_txt']} info@{BRAND_DOMAIN}.
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    langData:state.common.langData
  };
};

export default connect(
  mapStateToProps,
)(HelpView)
